'use client';
import { ProductCardContext } from '.';
import { ComponentProps, useContext } from 'react';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Layout } from '@/shared/ui/layout';
import { ProductCardProps } from './types';

type Props = ComponentProps<typeof Layout> &
    Partial<Pick<ProductCardProps, 'name'>> & {
        localizedName?: string;
    };
export const ProductCardName = ({ name, localizedName: localizedNameProp, media, ...props }: Props) => {
    const context = useContext(ProductCardContext);
    const getLocalizedValue = useGetLocalizedValue();

    const finalName = name ?? context.name;
    const localizedName = localizedNameProp ?? (finalName ? getLocalizedValue(finalName) : '');

    if (!localizedName) {
        return null;
    }

    return (
        <Layout
            element="span"
            data-testid="product-card-name"
            media={{
                initial: {
                    fontSize: '1.25rem',
                    fontWeight: 700,
                },
                ...media,
            }}
            {...props}
        >
            {localizedName}
        </Layout>
    );
};
